export const MAIN_COLOR = "#374151";
export const COLOUR_DISABLED = "#D4D4D4";
